import { Bug } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useDevDebug } from "@/contexts";
import { Badge } from "@/components/ui/badge";

export const DevDebugButton = () => {
  const { toggleDebugPanel, errors, logs } = useDevDebug();

  if (!import.meta.env.DEV) return null;

  const hasErrors = errors.length > 0;
  const recentLogs = logs.slice(-10);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={toggleDebugPanel}
            variant="outline"
            size="icon"
            className={`fixed bottom-4 left-4 z-50 h-12 w-12 rounded-full shadow-lg ${
              hasErrors 
                ? 'border-red-500 bg-red-50 hover:bg-red-100 dark:bg-red-950 dark:hover:bg-red-900' 
                : 'bg-background'
            }`}
          >
            <Bug className={`h-5 w-5 ${hasErrors ? 'text-red-600' : ''}`} />
            {hasErrors && (
              <Badge 
                variant="destructive" 
                className="absolute -top-1 -right-1 h-5 w-5 rounded-full p-0 flex items-center justify-center text-[10px]"
              >
                {errors.length}
              </Badge>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right" className="max-w-xs">
          <div className="space-y-1">
            <div className="font-semibold">Dev Debug Panel</div>
            <div className="text-xs text-muted-foreground">
              Press Ctrl+Shift+D or click to open
            </div>
            {hasErrors && (
              <div className="text-xs text-red-500 font-medium">
                {errors.length} error{errors.length !== 1 ? 's' : ''} detected
              </div>
            )}
            {recentLogs.length > 0 && (
              <div className="text-xs text-muted-foreground">
                {logs.length} log entries captured
              </div>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
